import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getUserProfile } from "../../../utils/API/getUserProfileAPI";

const UserName = () => {
  const { name, userType } = useSelector((state) => state.authReducer);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getUserProfile();
        if (response.success) {
          setUserData(response.data);
        } else {
          console.error("Failed to fetch user profile");
        }
      } catch (error) {
        console.error("Error fetching user profile:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="flex my-4">
      <div className="ml-5 w-1/5">
        {loading ? (
          <div className="mini-photo-wrapper w-8 h-8 bg-gray-200 rounded-full"></div> 
        ) : (
          <a className="mini-photo-wrapper" href="/#">
            <img
              className="mini-photo rounded-full w-8 h-8" 
              src={userData?.profile_image || "/images/user.svg"}
              alt="User"
            />
          </a>
        )}
      </div>
      <div className="flex flex-col ml-3 justify-start w-4/5 ">
        <span className="text-sm font-medium text-wrap">{name || "Username"}</span>
        <span className="text-[10px] capitalize">{userType || "UserType"}</span>
      </div>
    </div>
  );
};

export default UserName;
